export default "__VITE_ASSET__CdYu1Djr__"